export default __webpack_public_path__ + "static/media/tempStore9.e5b0d217.png";